import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { Box, Flex, Spinner, Text } from '@chakra-ui/react';
import { Button } from '@/components/ui/Button';
import { JobCategoryForm } from '@/features/job-categories/components/JobCategoryForm';
import {
  jobCategoryQueries,
  useDeleteJobCategory,
  useUpdateJobCategory,
} from '@/features/job-categories/api/jobCategoryQueries';

export const Route = createFileRoute('/_authenticated/job-categories/$categoryId')({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(jobCategoryQueries.detail(params.categoryId)),
  component: JobCategoryDetailPage,
});

function JobCategoryDetailPage() {
  const { categoryId } = Route.useParams();
  const navigate = useNavigate();
  const { data, isLoading } = useQuery(jobCategoryQueries.detail(categoryId));
  const updateMutation = useUpdateJobCategory();
  const deleteMutation = useDeleteJobCategory();

  if (isLoading) {
    return (
      <Flex justify="center" py={8}>
        <Spinner />
      </Flex>
    );
  }

  const category = data?.item;

  return (
    <Box>
      <Flex justify="space-between" align="center" mb={6}>
        <Text fontSize="2xl" fontWeight="bold">
          職種カテゴリ詳細
        </Text>
        <Button variant="outline" onClick={() => navigate({ to: '/job-categories' })}>
          一覧に戻る
        </Button>
      </Flex>

      <Box bg="bg.panel" p={6} borderRadius="md" shadow="sm">
        <JobCategoryForm
          initialValues={category ?? { id: categoryId, name: '' }}
          onSubmit={async (values) => {
            await updateMutation.mutateAsync({ id: categoryId, ...values });
          }}
          submitLabel="更新"
        />
        <Box mt={6} pt={4} borderTop="1px solid" borderColor="border.DEFAULT">
          <Button
            colorPalette="red"
            variant="outline"
            onClick={async () => {
              if (!confirm('このカテゴリを削除してよろしいですか？')) return;
              await deleteMutation.mutateAsync(categoryId);
              navigate({ to: '/job-categories' });
            }}
          >
            削除
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
